import { ChangeUserPlanDto } from "../../model/plan/payment/dto/ChangeUserPlanDto";
import { CreateCheckoutDto } from "../../model/plan/payment/dto/CreateCheckoutDto";
import { GetAllPlanResponseDto } from "../../model/plan/payment/dto/GetAllPlansResponseDto";
import { GenericWithUserId } from "../../model/shared/dto/GenericWithUserId";
import { AtiraApi } from "../AxiosClient";

export class PaymentAxios {
  static createCheckout(dto: CreateCheckoutDto) {
    return AtiraApi.post<string>("/payment/checkout", dto).then(
      ({ data }) => data,
    );
  }

  static getAllPlans() {
    return AtiraApi.get<GetAllPlanResponseDto>("/payment/list-plans").then(
      ({ data }) => data,
    );
  }

  static cancelPlan() {
    return AtiraApi.delete<void>("/payment/cancel-user-plan").then(
      ({ data }) => data,
    );
  }

  static resumeCancelledPlan() {
    return AtiraApi.patch<void>("/payment/resume-user-plan").then(
      ({ data }) => data,
    );
  }

  static getUpdatePaymentMethodURL() {
    return AtiraApi.get<string>("/payment/get-update-payment-method-url").then(
      ({ data }) => data,
    );
  }

  static changePlan(dto: ChangeUserPlanDto) {
    return AtiraApi.patch<void>("/payment/change-user-plan", dto).then(
      ({ data }) => data,
    );
  }

  static closeRestrictedContentBanner(userId: GenericWithUserId) {
    return AtiraApi.patch(`/payment/start-free-trial/dismissed-banner`, {
      userId,
    }).then(({ data }) => data);
  }
}
